import {getCountryCodeFromUrl} from '@shared/api/api';
import store from '@store';
import {lazy} from 'react';

const ROUTES = [
  {
    path: '/login',
    exact: true,
    component: lazy(() => import('../pages/Login')),
    name: 'LoginPage',
    isPrivate: false,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/register',
    exact: true,
    component: lazy(() => import('../pages/Login')),
    name: 'LoginPage',
    isPrivate: false,
    countries: ['MY'],
  },
  {
    path: '/loan-details/:loanId',
    exact: true,
    component: lazy(() => import('../pages/LoanDetails')),
    name: 'Loan Details',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/my-advance',
    exact: true,
    component: lazy(() => import('../pages/MyLoans')),
    name: 'My Advances',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/',
    exact: true,
    component: lazy(() => import('../pages/Dashboard')),
    name: 'DashboardPage',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/loan-application-process/:loanId?/:status?',
    exact: true,
    component: lazy(() => import('../pages/LoanApplication')),
    name: 'loan-application-process',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/past-payment-history/:loanId',
    exact: true,
    component: lazy(() => import('../pages/Transactions')),
    name: 'Past Payment History',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/repayment/:loanId',
    exact: true,
    component: lazy(() => import('../pages/ManualRepayment/container')),
    name: 'repayment',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/my-profile',
    exact: true,
    component: lazy(() => import('../pages/MyProfile')),
    name: 'my-profile',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/sales-platform/:step',
    exact: true,
    component: lazy(() => import('../pages/SalesPlatform')),
    name: 'sales-platform',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/direct-debit-setup/:status?',
    exact: false,
    component: lazy(() => import('../pages/DirectDebit')),
    name: 'DDSetup',
    isPrivate: false,
    countries: ['MY'],
  },
  {
    path: '/paylater-direct-debit-setup/:status?',
    exact: false,
    component: lazy(() => import('../pages/DirectDebit')),
    name: 'PLDDSetup',
    isPrivate: false,
    countries: ['MY'],
  },
  {
    path: '/my-pockets',
    exact: true,
    component: lazy(() => import('../pages/MyPockets')),
    name: 'My Pockets',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/add-pocket',
    exact: true,
    component: lazy(() => import('../pages/MyPockets/AddPocket')),
    name: 'Add Pocket',
    isPrivate: true,
    countries: ['MY', 'ID'],
  },
  {
    path: '/add-pocket/pg-pos-system',
    exact: true,
    component: lazy(() => import('../pages/MyPockets/AddPocket/POS')),
    name: 'Add Pocket - POS',
    isPrivate: true,
    countries: ['MY', 'ID'],
  },
  {
    path: '/conai',
    exact: true,
    component: lazy(() => import('../pages/Conai')),
    name: 'Conai',
    isPrivate: true,
    countries: ['MY', 'ID'],
  },
  {
    path: '/payment-details/:loanId',
    exact: true,
    component: lazy(() => import('../pages/PaymentDetails')),
    name: 'Payment Details',
    isPrivate: true,
    countries: ['MY'],
  },
  {
    path: '/payment-details/status/:status?',
    exact: true,
    component: lazy(
      () => import('../pages/PaymentDetails/component/PaymentStatus')
    ),
    name: 'Payment Status',
    isPrivate: true,
    countries: ['MY'],
  },
  {
    path: '/payment',
    exact: false,
    component: lazy(() => import('../pages/Payment')),
    name: 'Public Payment',
    isPrivate: false,
    countries: ['MY'],
  },
  {
    path: '/payment/status/:status?',
    exact: false,
    component: lazy(() => import('../pages/Payment/component/PaymentStatus')),
    name: 'Public Payment Status',
    isPrivate: false,
    countries: ['MY'],
  },
  {
    path: '/sso',
    exact: false,
    component: lazy(() => import('../pages/Login')),
    name: 'SSOLoginPage',
    isPrivate: false,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/download-transaction-summary/:loanId',
    exact: true,
    component: lazy(() => import('../pages/DownloadTransaction')),
    name: 'Download Transaction Summary',
    isPrivate: true,
    countries: ['MY'],
  },
  {
    path: '/form/e/:token',
    exact: false,
    component: lazy(() => import('../pages/SmartForm')),
    name: 'SmartForm',
    isPrivate: false,
    countries: ['MY'],
  },
];

export default ROUTES;

export const useFilteredRoutes = () => {
  const {isPaylater} = store.getState().login;
  const {pocketSubmitted, isIndrive} = store.getState().dashboard;
  const countryCode = getCountryCodeFromUrl();

  return ROUTES.filter((route) => {
    const isCountryMatch = route.countries.includes(countryCode);
    const isLoanApplicationRoute = route.name === 'loan-application-process';
    const newPocketRoute = [
      '/add-pocket',
      '/add-pocket/pg-pos-system',
      '/conai',
    ];

    if (isPaylater && isLoanApplicationRoute && !isIndrive) {
      return false;
    }

    if (pocketSubmitted && newPocketRoute.includes(route.path)) {
      const searchParams = new URLSearchParams(window.location.search);
      const isExistingAccount = searchParams.get('existingAccount') === 'true';
      if (route.path === '/conai' && isExistingAccount) {
        return isCountryMatch;
      }
      return false;
    }

    return isCountryMatch;
  });
};
